import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';
import ConfirmationDialog from 'Components/UI/ConfirmationDialog';

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  left: {
    flex: '2 0 0',
    marginRight: theme.spacing(1),
  },
  right: {
    flex: '1 0 0',
  },
  label: {
    justifyContent: 'flex-start',
  },
}));

export default function Contact({
  handleUpdate,
  client,
}) {
  const [changeLoginEmailAddressData, setChangeLoginEmailAddressData] = useState(null);
  const classes = useStyles();

  return (
    <>
      {client.attr('isPrimary') === 'true' && (
        <>
          <MetaControl
            attrName="addressLine1"
            onChange={value => handleUpdate(client.attr('addressLine1', value))}
            resource={client}
          />
          <MetaControl
            attrName="addressLine2"
            onChange={value => handleUpdate(client.attr('addressLine2', value))}
            resource={client}
          />
          <div className={classes.row}>
            <MetaControl
              className={classes.left}
              attrName="city"
              onChange={value => handleUpdate(client.attr('city', value))}
              resource={client}
            />
            <MetaControl
              className={classes.right}
              attrName="state"
              onChange={value => handleUpdate(client.attr('state', value))}
              resource={client}
            />
          </div>
          <MetaControl
            attrName="postalCode"
            onChange={value => handleUpdate(client.attr('postalCode', value))}
            resource={client}
          />
        </>
      )}
      <MetaControl
        attrName="preferredContact"
        onChange={(value) => {
          client.attr('preferredContact', value);
          handleUpdate(client);
        }}
        resource={client}
      />
      {changeLoginEmailAddressData && (
      <ConfirmationDialog
        onCancel={() => setChangeLoginEmailAddressData(null)}
        title="Do you want to change your login email?"
        message={`${changeLoginEmailAddressData.newLoginEmailAddress.attr('address')} will become the new login email address`}
        onConfirm={() => {
          changeLoginEmailAddressData.newLoginEmailAddress.attr('type', 'login');
          if (changeLoginEmailAddressData.originalLoginEmailAddress) {
            changeLoginEmailAddressData.originalLoginEmailAddress.attr('type', 'other');
          }
          setChangeLoginEmailAddressData(null);
          handleUpdate(client);
        }}
        showCloseIcon={false}
      />
      )}
    </>
  );
}

Contact.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};
